<script>
import WebglRenderer from "../webgl/WebglRenderer";
import canvasBase from "./CanvasBase";
import { limit, debounce } from "../../helpers/utils";
export default {
  extends: canvasBase,
  name: "canvasWebgl",
  props: {
    img: [HTMLImageElement, HTMLCanvasElement],
    colorSettings: Object,
    octColorSettings: Object,
    thicknessMapColorSettings: Object,
    lastImgSize: Object,
    usePixelCanvas: Number,
    bounds: Object,
    componentName: String,
    isSideBySide: Boolean
  },
  methods: {
    draw() {
      if (this.renderer && !this.renderer.isContextLost) {
        if (this.bounds){
          this.renderer.limitDrawBounded(
            this.img,
            this.lastImgSize,
            this.usePixelCanvas,
            this.bounds
          );
          this.renderer.debounceDrawBounded(
            this.img,
            this.lastImgSize,
            this.usePixelCanvas,
            this.bounds
          );
        } else{
          this.renderer.limitDraw(
            this.img,
            this.lastImgSize,
            this.usePixelCanvas
          );
          this.renderer.debounceDraw(
            this.img,
            this.lastImgSize,
            this.usePixelCanvas
          );
        }
      }
    },

    setupDrawCall() {
      let drawCallback = this.renderer.draw.bind(this.renderer);
      this.renderer.limitDraw = limit(drawCallback, 20);
      this.renderer.debounceDraw = debounce(drawCallback, 50);
      
      let boundedDrawCallback = this.renderer.drawBounded.bind(this.renderer);
      this.renderer.limitDrawBounded = limit(boundedDrawCallback, 20);
      this.renderer.debounceDrawBounded = debounce(boundedDrawCallback, 50);
    },

    restoreDrawCall(e) {
      e.preventDefault();
      console.log("webglcontextrestore occured");
      this.createRenderer();
      this.setupDrawCall();
    },

    clearDrawCall(e) {
      e.preventDefault();
      console.log("webglcontextlost occured");
    },

    createRenderer() {
      this.renderer = new WebglRenderer(this.$refs.canvas);
      this.renderer.prepareWebgl();
      this.renderer.canvasSize = this.canvasSize;
      this.renderer.transform = this.transform;
      this.renderer.imgSize = this.imgSize;
      this.renderer.isFlipped = this.isFlipped;
      this.renderer.isFlipped90 = this.isFlipped90;
      this.renderer.isFlipped270 = this.isFlipped270;
      this.renderer.flippedX = this.flippedX;
      this.renderer.colorSettings = this.colorSettings;
      this.renderer.octColorSettings = this.octColorSettings;
      this.renderer.thicknessMapColorSettings = this.thicknessMapColorSettings;
      if (this.isSideBySide)
        this.renderer.isSideBySide = this.isSideBySide;
      if (this.componentName)
        this.renderer.componentName = this.componentName;
      this.setupDrawCall();
      if (this.autodraw) this.redraw();

      this.renderer.canvas.addEventListener("webglcontextlost", this.clearDrawCall, false);

      this.renderer.canvas.addEventListener("webglcontextrestored", this.restoreDrawCall, false);
    },
  },
  watch: {
    img() {
      if (!this.img) this.renderer.clear();
      if (this.autodraw) this.redraw();
    },
    colorSettings: {
      handler() {
        if (this.colorSettings !== this.renderer.colorSettings)
          this.renderer.colorSettings = this.colorSettings;

        if (this.autodraw) this.redraw();
      },
      deep: true
    },
    octColorSettings: {
      handler() {
        if (this.octColorSettings !== this.renderer.octColorSettings)
          this.renderer.octColorSettings = this.octColorSettings;

        if (this.autodraw) this.redraw();
      },
      deep: true
    },
    thicknessMapColorSettings: {
      handler() {
        if (
          this.thicknessMapColorSettings !==
          this.renderer.thicknessMapColorSettings
        )
          this.renderer.thicknessMapColorSettings = this.thicknessMapColorSettings;

        if (this.autodraw) this.redraw();
      },
      deep: true
    },
    usePixelCanvas() {
      if (this.autodraw) this.redraw();
    }
  },
  beforeDestroy() {
    this.renderer.clearWebGL();
  }
};
</script>